import ajax from '@/resources/myApi';

const partService = {
  getShipViaList,
  /*
  addRfp,
  getRfpById,
  addCrfqPart,
  updateCrfqPart,
  getCrfqPartById,
  checkIfCrfqHasRfp,
  */
  getMatchedPartNumbers,
}

async function getShipViaList() {
  try {
    const { data } = await ajax.get('api/common/GetShipVia', {
      name: 'ship via list',
    });
    return data;
  } catch { }
}

async function getMatchedPartNumbers(partNumber) {
  try {
    const { data } = await ajax
      .get(`api/Part?pageSize=20&filters=PartNumber.Contains("${partNumber}")`, {
        name: 'part numbers',
      });
    return data.items;
  } catch { }
}
/*
async function addRfp(body) {
  try {
    const { data } = await ajax.post('api/crfq', {
      name: 'RFP',
      body,
    });
    return data.id;
  } catch {}
}

async function getRfpById(id) {
  try {
    const { data } = await ajax.get(`api/crfq/${id}`, {
      name: 'RFP',
    });
    return data;
  } catch {}
}

async function addCrfqPart(crfqPart) {
  try {
    const { data } = await ajax.post('api/crfqline', {
      name: 'CRFQ part',
      body: crfqPart,
    });
    return data;
  } catch {}
}

async function updateCrfqPart(crfqPart) {
  try {
    const { data } = await ajax.put(`api/crfqline/${crfqPart.id}`, {
      name: 'CRFQ part',
      body: crfqPart,
    });
    return data;
  } catch {}
}



async function getCrfqPartById(id) {
  try {
    const { data } = await ajax.get(`api/crfqline/${id}`, {
      name: 'CRFQ part',
    });
    return data;
  } catch {}
}

async function checkIfCrfqHasRfp(crfqId) {
  try {
    const hasRfp = await ajax.get(`api/CRFQ/CheckIfCrfqHasRfp/${crfqId}`, {
      name: 'Ultra RFP',
    });
    return hasRfp;
  } catch {}
}
*/
export default partService;
